import Feather from 'feather-icons';
import Flickity from 'flickity';

Feather.replace();

const products = document.querySelector('.flickity');

if (products) {
    const flickity = new Flickity(products, {
        cellSelector: '.product',
        // friction: 0.18,
        // initialIndex: 2,
        // pageDots: false,
        prevNextButtons: false,
        // selectedAttraction: 0.01,
        // wrapAround: true,
    });
    // flickity.focus();
    if (2 > flickity.cells.length) {
        flickity.pageDots.holder.classList.add('hidden');
    }
    flickity.on('scroll', () => {
        flickity.slides.forEach(( slide, i ) => {
            let isSelected = i === flickity.selectedIndex;
            slide.cells[0].element.style.transform = 'scale(' + (isSelected ? '1' : '0.85') + ')';
        });
    });
}

